// Rótulos de status de risco ANBIMA — os valores que o backend emite em
// `status_desenquadramento` e que a UI compara e exibe (filtro do overview,
// badge da lista, detalhamento da carteira e card do perfil).
//
// Constante única porque a string é o CONTRATO com o backend: cada literal
// repetido é uma chance de divergir em acento ou caixa e a comparação passar
// a falhar em silêncio — o status some da tela sem erro nenhum.
//
// Bucket que o BACKEND cria só para os gráficos, quando
// `status_desenquadramento` vem nulo ou vazio
// (`usecase_consolidator_overview.py:518-519`). NÃO é um status do contrato:
// não aparece na lista e não tem legenda de domínio.

export const ANBIMA_STATUS = {
  ACIMA: 'Acima do Risco',
  PROXIMO: 'Próximo do Risco',
  DENTRO: 'Dentro do Risco',
  // Escritório sem máximos por classe configurados. NÃO é sinônimo de
  // "Dentro do Risco": sem teto não dá para afirmar conformidade.
  NAO_CONFIGURADO: 'Não Configurado',
}

export const ANBIMA_SEM_DADO = 'Não Definido'
